import React from 'react'
import Select from 'react-select'
import { useController } from 'react-hook-form'

function ShopifyFormSelect({
	name,
	control,
	onChange,
	valueFromField,
	component: Component = Select,
	defaultValue = null,
	...props
}) {
	const { field } = useController({
		name,
		control,
		defaultValue,
	})

	const resolvedValue = valueFromField ? valueFromField(field.value) : field.value

	return (
		<Component
			{...props}
			name={field.name}
			value={resolvedValue}
			onBlur={field.onBlur}
			onChange={(selectedOption, actionMeta) => {
				field.onChange(selectedOption)
				if (onChange)
					onChange(selectedOption, actionMeta)
			}}
			ref={field.ref}
		/>
	)
}

export default ShopifyFormSelect